/**
 * 任务指派-所有任务模块
 * allAssignmentsModule
 * author: Qian.qianchen 2019-05-08
 */
"use strict";
angular.module('allAssignmentsModule', [])
    .controller('allAssignmentsCtrl', ['$scope', 'trsHttpService', '$state', 'taskAssignmentService', '$q', 'modalDialog', 'trsspliceString', function($scope, trsHttpService, $state, taskAssignmentService, $q, modalDialog, trsspliceString) {

        initStatus();
        initData();
        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                isOnlyToday: false,
                keyword: "",
                page: {
                    CURRPAGE: 1,
                    PAGESIZE: 10
                },
                params: {
                    serviceid: "mlf_taskcommand",
                    methodname: "queryTaskCommands",
                    IsMine: 0,
                    BeginDate: "",
                    EndDate: "",
                    TaskName: "",

                },
                statusOptions: taskAssignmentService.initStatus(0),
                selectedOption: {
                    name: "全部状态",
                    value: -2
                }
            };
            $scope.data = {
                selectedArray: []
            }
        }
        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            getAssignmentRights();
            requestData();
        }
        /**
         * [getAssignmentRights description] 获取权限
         * @return {[type]} [description]
         */
        function getAssignmentRights() {
            taskAssignmentService.getRights().then(function(result) {
                $scope.status.rights = result;
            });
        }
        /**
         * [requestData description] 数据获取
         * @return {[type]} [description]
         */
        function requestData() {
            let defer = $q.defer();
            let params = angular.copy($scope.status.params);
            params.TaskName = $scope.status.keyword;
            params.BeginDate = angular.isDefined($scope.data.fromdate) && $scope.data.fromdate != "" ? $scope.data.fromdate : "";
            params.EndDate = angular.isDefined($scope.data.untildate) && $scope.data.untildate != "" ? $scope.data.untildate : "";
            params.Status = $scope.status.selectedOption.value != -2 ? $scope.status.selectedOption.value : "";
            params.Today = $scope.status.isOnlyToday ? 1 : "";
            params.PageSize = $scope.status.page.PAGESIZE;
            params.CurrPage = $scope.status.page.CURRPAGE;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "POST").then(function(data) {
                $scope.data.items = data.DATA;
                $scope.status.page = data.PAGER;
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [createAssignment description] 新建任务
         * @return {[type]} [description]
         */
        $scope.editAssignment = function(assignment) {
            let params;
            if (angular.isDefined(assignment)) {
                params = {
                    platform: 0,
                    assignmentid: assignment.TASKCOMMANDID,
                    istrial: 0
                };
            } else {
                params = {
                    platform: 0,
                    istrial: 0
                };
            }
            $state.go('front.plan.taskassignment.assignments.assignmentedit', params);
        }
        /**
         * [initList description] 列表数据请求
         * @return {[type]} [description]
         */
        $scope.initList = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.status.page.CURRPAGE = 1;
                $scope.data.selectedArray = [];
                requestData();
            }
        }
        /**
         * [pageChanged description] 分页请求数据
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            requestData();
        }
        /**
         * [isChecked description] 判断稿件是否选中
         * @param  {[type]}  item [description] 稿件
         * @return {Boolean}      [description]
         */
        $scope.isChecked = function(item) {
            return $scope.data.selectedArray.some(function(_item, index) {
                return item.TASKCOMMANDID == _item.TASKCOMMANDID;
            });
        }
        /**
         * [selectItem description] 稿件选择/取消选择
         * @param  {[type]} item [description] 稿件
         * @return {[type]}      [description]
         */
        $scope.selectItem = function(item) {
            if ($scope.isChecked(item)) {
                $scope.data.selectedArray = $scope.data.selectedArray.filter(function(_item, index) {
                    return item.TASKCOMMANDID != _item.TASKCOMMANDID
                });
            } else {
                $scope.data.selectedArray.push(item)
            }
        }
        /**
         * [trialAssignment description] 任务审核
         * @param  {[type]} item [description] 任务
         * @return {[type]}      [description]
         */
        $scope.trialAssignment = function(item) {
            let defer = $q.defer();
            if (angular.isDefined(item) || $scope.data.selectedArray.length == 1) {
                let assignmentId = angular.isDefined(item) ? item.TASKCOMMANDID : $scope.data.selectedArray[0].TASKCOMMANDID;
                $state.go('front.plan.taskassignment.assignments.assignmentedit', {
                    platform: 0,
                    assignmentid: assignmentId,
                    istrial: 1
                });
            } else {
                modalDialog.confirmModal('批量审核', '是否确认审核通过选中的' + $scope.data.selectedArray.length + '个任务？', function() {
                    var params = {
                        serviceid: "mlf_taskcommand",
                        methodname: "CheckTask",
                        TaskIds: trsspliceString.spliceString($scope.data.selectedArray, 'TASKCOMMANDID', ',')
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "POST").then(function(data) {
                        modalDialog.alertType('审核成功', '', 'success', false);
                        $scope.initList();
                        defer.resolve();
                    }, function() {
                        $scope.initList();
                        defer.reject();
                    });
                });
            }
            return defer.promise;
        }
        /**
         * [assignmentDetail description] 任务详情
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.assignmentDetail = function(item) {
            taskAssignmentService.assignmentDetail(item.TASKCOMMANDID, 0);
        }
        /**
         * [createNewReport description] 关联选题
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.createNewReport = function(item) {
            taskAssignmentService.createNewReport(item.TASKCOMMANDID);
        }
        /**
         * [assignmentLog description] 任务日志
         * @param  {[type]} item [description] 任务
         * @return {[type]}      [description]
         */
        $scope.assignmentLog = function(item) {
            taskAssignmentService.assignmentLog(item.TASKCOMMANDID);
        }
        /**
         * [todayToggle description] 只看当天
         * @return {[type]} [description]
         */
        $scope.todayToggle = function() {
            $scope.status.isOnlyToday = !$scope.status.isOnlyToday;
            $scope.initList();
        }

        /**
         * [relevanceManuscript 关联稿件]
         * @return {[type]} [description]
         */
        $scope.relevanceManuscript = function(item){
            taskAssignmentService.relevanceManuscript(item).then(function(result){
                modalDialog.alertType(result.DETAIL, '', 'success', false, function(){
                    requestData();
                });
            });
        }
    }]);